<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de Atendimentos">
            <template v-slot:actions>
                <rkm-button
                @click="$router.push({ name: 'atencao-basica-visita-domiciliar'})"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.List.handleCadastrar()"
                    autorize="store-atencao-basica-visita-domiciliar"
                    color="primary"
                >
                    Cadastrar atendimento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    ref="List"
                    :id="id"
                    @loaded="loaded"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/visita-domiciliar/List'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import { unmask } from '@/mixins'

export default {
    components: {
        List,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    data: () => ({
        additionals: null,
        enums: {classificacao},
        cidadao: null,
    }),
    methods: {
        loaded(value) {
            this.additionals = value.additionals
            this.cidadao = value.cidadao
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.cidadao.cidadaoId,
                nome: this.cidadao.nome,
                dataNascimento: this.cidadao.dataNascimento,
                nomeMae: this.cidadao.nomeMae,
                cns: this.cidadao.cns ? this.unMaskCns(this.cidadao.cns) : null,
                cpf: this.cidadao.cpf ? this.unMaskCpf(this.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.cidadao, {
                ...item,
                sexoId: item.sexo.id,
                sexoDescricao: item.sexo.descricao,
            })
        },
    },
    mixins: [ unmask ],
    props: {
        id: { type: Number, default: null }
    },
}
</script>